import React from "react";
import { Paper, Stack, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * A dashboard panel: white card, soft shadow, hairline border, optional heading with a hint and a
 * right-aligned action.
 *
 * Visually this is the same card the admin dashboard uses, but it is deliberately a separate
 * component rather than an import from src/pages/Dashboard/ — those files belong to the admin
 * console and nothing here should be able to change how the admin dashboard renders.
 */
export default function TutorPanel({ title, hint, action, children, sx = {}, ...rest }) {
  return (
    <Paper
      sx={{
        p: 2,
        height: "100%",
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        border: "1px solid #eef0f4",
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
      {...rest}
    >
      {title && (
        <Stack direction="row" alignItems="center" spacing={0.75} mb={1}>
          <Typography variant="subtitle1" fontWeight={700} sx={{ color: "#111827" }}>
            {title}
          </Typography>
          {hint && (
            <Tooltip title={hint} arrow placement="top">
              <InfoOutlinedIcon sx={{ fontSize: 15, color: "#9aa1ac", cursor: "help" }} />
            </Tooltip>
          )}
          {action && <Stack direction="row" sx={{ ml: "auto" }}>{action}</Stack>}
        </Stack>
      )}
      {children}
    </Paper>
  );
}
